// extracted by mini-css-extract-plugin
module.exports = {"root":"PdfViewer_root__3kO6Q","pdfviewerPage":"PdfViewer_pdfviewerPage__1rWwR"};